var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"banner-box"},[_c('img',{attrs:{"src":_vm.cfg.ossDomain + '/banner.png',"alt":""},on:{"click":function($event){return _vm.advertJump(_vm.homeSwiper[0].customUrl)}}})])])}
var staticRenderFns = []

export { render, staticRenderFns }